import React, { useEffect, useMemo, useState } from "react";
import Prismic from "@prismicio/client";
import { useLocation } from "react-router-dom";
import "../Css/work.css";

import "../Css/caseStudy.css";
import "../Css/about.css"; // Import the separate CSS file
import CaseStudy from "./caseStudyTest";
import Logo from "../Assets/logo_harshit.png";


export default function CaseStudyPage() {
  const [isLoading, setIsLoading] = useState(true);

  const apiEndpoint = "https://harshitsharma.prismic.io/api/v2";
  const accessToken =
    "MC5ZYUVtbXhNQUFETUFuODZN.77-977-9Ye-_ve-_vX8o77-977-977-977-977-9a--_ve-_ve-_ve-_ve-_ve-_vQITBF5h77-977-977-977-977-977-9TO-_vQ";

  const client = Prismic.client(apiEndpoint, { accessToken });
  const [caseStudy, setCaseStudy] = useState([]);
  const [isProtected, setIsProtected] = useState(false);
  const [caseStudyUid, setCaseStudyUid] = useState(null);

  // Prismic's REST API can restrict a query to a specific set of fields via
  // `fetch`. Locked case studies use this so the actual content — tiles,
  // meaning every image and paragraph — is never requested from Prismic (and
  // never sits in the browser/React state) until the password is confirmed.
  // Previously the full document was fetched unconditionally and `locked`
  // only hid it in the UI, so the "protected" content was already sitting in
  // the network response and React state for anyone to read before ever
  // seeing the password prompt.
  const PREVIEW_FIELDS = "case_study.title,case_study.locked,case_study.password";

  const location = useLocation();
  useEffect(() => {
    // Re-runs whenever the URL's uid segment changes — navigating from one
    // case study to another (e.g. the "View Next Case Study" card) keeps
    // this component mounted, so without pathname in the deps the effect
    // only ever fired once and the page would silently keep showing the
    // previous case study's data while the URL changed underneath it.
    const n = location.pathname.lastIndexOf("/");
    const result = location.pathname.substring(n + 1);
    setCaseStudy([]);
    setIsProtected(false);
    setIsLoading(true);
    setCaseStudyUid(result);

    const getCaseStudyData = async (uid) => {
      const preview = await client.getByUID("case_study", uid, {
        fetch: PREVIEW_FIELDS,
      });
      if (!preview) {
        setIsLoading(false);
        return;
      }

      if (preview.data.locked) {
        // Stop here — only the title and the value needed to check the
        // password ever reach the browser for a locked case study.
        setCaseStudy(preview.data);
        setIsProtected(false);
        setIsLoading(false);
        return;
      }

      const full = await client.getByUID("case_study", uid);
      if (full) {
        setCaseStudy(full.data);
        setIsProtected(true);
      }
      setIsLoading(false);
    };
    getCaseStudyData(result);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  const login = (params) => async (event) => {
    event.preventDefault();
    const inputPassword = event.target[0].value;
    if (inputPassword !== caseStudy.password) return;

    setIsLoading(true);
    const full = await client.getByUID("case_study", caseStudyUid);
    if (full) {
      setCaseStudy(full.data);
      setIsProtected(true);
    }
    setIsLoading(false);
  };
  const themeColors = caseStudy.color?.[0];
  const themeStyle = useMemo(
    () => ({
      "--bg": themeColors?.bg || "#010510",
      "--grid-line": themeColors?.border || "#07245a",
      "--case-green": themeColors?.green_heading || "#3075ff",
      "--bg-light": themeColors?.bg_light || "#00153D",
      "--case-quotation": themeColors?.quotation || "#69ffca",
      "--case-heading": themeColors?.quotation || "#699CFF",
      "--case-heading-points": themeColors?.heading_points || "#e7ff7c",
    }),
    [themeColors],
  );

  useEffect(() => {
    const root = document.documentElement;
    Object.entries(themeStyle).forEach(([key, value]) => {
      root.style.setProperty(key, value);
    });
    return () => {
      Object.keys(themeStyle).forEach((key) => {
        root.style.removeProperty(key);
      });
    };
  }, [themeStyle]);

  return (
    <div style={themeStyle}>
       <nav className="hero-nav" style={themeStyle}>
          <div className="nav-grid-lines">
            {Array.from({ length: 16 }).map((_, i) => (
              <div
                className="nav-line-cell"
                key={i}
                style={{ "--line-delay": `${i * 0.03}s` }}
              />
            ))}
          </div>

          <div className="hero-brand">
            <a href="/">
              {" "}
              <img src={Logo} alt="logo" className="hero-logo-icon" />
            </a>
            <div className="hero-nav-links">
              <a href="/archives">Archives</a>,<a href="/about">About</a>,
              <a href="#contact">Contact</a>
            </div>
          </div>

          <div className="hero-nav-info">
            <div className="info-block">
              <span>Currently Lead</span>
              <span>Product Designer @ MakseGroup</span>
            </div>
            <div className="info-block">
              <span>Based in</span>
              <span>Gurugram,India</span>
            </div>
          </div>
        </nav>
      <CaseStudy
        caseStudy={caseStudy}
        isProtected={isProtected}
        isLoading={isLoading}
        login={login}
      />
    </div>
  );
}
